module.exports = __webpack_public_path__ + "static/media/wall19.452a6565.jpeg";